import { ArrayFieldItemTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/ArrayFieldItemTemplate';
import { ArrayFieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/ArrayFieldTemplate';
import { BaseInputTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/BaseInputTemplate';
import { CheckboxesWidget } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/CheckboxesWidget';
import { CheckboxWidget } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/CheckboxWidget';
import { DescriptionFieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/DescriptionFieldTemplate';
import { ErrorListTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/ErrorListTemplate';
import { FieldErrorTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/FieldErrorTemplate';
import { FieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/FieldTemplate';
import { HorizontalLayoutObjectFieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/HorizontalLayoutObjectFieldTemplate';
import { ObjectFieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/ObjectFieldTemplate';
import { RadioWidget } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/RadioWidget';
import { SARNarrativeField } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/SARNarrativeField';
import { SelectWidget } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/SelectWidget';
import { TextareaWidget } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/TextareaWidget';
import { TitleFieldTemplate } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/TitleFieldTemplate';

export const templates = {
  ArrayFieldTemplate,
  ArrayFieldItemTemplate,
  BaseInputTemplate,
  DescriptionFieldTemplate,
  ErrorListTemplate,
  FieldTemplate,
  FieldErrorTemplate,
  ObjectFieldTemplate,
  TitleFieldTemplate,
  // custom template registration
  HorizontalLayout: HorizontalLayoutObjectFieldTemplate,
};

export const widgets = {
  CheckboxWidget,
  CheckboxesWidget,
  SelectWidget,
  RadioWidget,
  TextareaWidget,
};

export const fields = {
  SARNarrativeField,
};
